<template>
  <div class="">
    <demo-login-modal />
    <section class="section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-3 bg-gradient-default shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container pb-300">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3 text-white">Visa Form</h2>
          </div>
        </div>
      </div>
    </section>
    <div class="container">
      <section class="section pt-lg-0 section-contact-us">
        <div class="container">
          <div class="row justify-content-center mt--300">
            <div class="col-lg-12">
              <card gradient="secondary" shadow body-classes="p-lg-5">
                <form action method="post" class="form-inner" id="visa-form">
                  <div class="row form-group" id="visaform">
                    <div class="col-lg-12 col-sm-12 mb-3">
                      <h5>Select Country</h5>
                      <multiselect
                        :multiple="false"
                        placeholder="Select Country"
                        :options="countryoptions"
                        v-model="countryvalue"
                        label="name"
                        open-direction="bottom"
                        :searchable="true"
                        :loading="isCountryLoading"
                        :track-by="visa_country"
                        :internal-search="false"
                        :clear-on-select="false"
                        :close-on-select="true"
                        :options-limit="300"
                        :limit-text="limitText"
                        :max-height="600"
                        :show-no-results="true"
                        :hide-selected="true"
                        @search-change="getCountry"
                        @input="getenter"
                        @select="optionSelected"
                      >
                      </multiselect>
                    </div>
                    <div class="col-lg-12 col-sm-12">
                      <h5>Entry</h5>
                      <multiselect
                        :multiple="false"
                        placeholder="Select Enter"
                        :options="enteroption"
                        v-model="entervalue"
                        label="visa_entry"
                        open-direction="bottom"
                        :searchable="true"
                        :loading="isEnterLoading"
                        :track-by="enter_country"
                        :internal-search="false"
                        :clear-on-select="false"
                        :close-on-select="true"
                        :options-limit="300"
                        :limit-text="limitText"
                        :max-height="600"
                        :show-no-results="true"
                        :hide-selected="true"
                        @search-change="executeLoader"
                        @input="executeLoader"
                        ref="dropdown"
                      >
                      </multiselect>
                    </div>
                    <div class="col-12">
                      <hr />
                    </div>
                    <div
                      class="row w-100 mx-auto"
                      v-if="this.checkdetails == true"
                    >
                      <div class="col-lg-2 col-sm-12">
                        <h5>Nos. of Person</h5>
                        <number-input
                          class="noofperson"
                          @change="checkadults"
                          v-model="guests"
                          :min="1"
                          :max="6"
                          inline
                          controls
                        ></number-input>
                      </div>
                      <div class="col-lg-4 col-sm-12">
                        <h5>Check-In Date</h5>
                        <div
                          class="
                            input-daterange
                            datepicker
                            row
                            align-items-center
                            flatpickr
                          "
                        >
                          <div class="col">
                            <!-- <base-input addon-left-icon="fa-lg calendar"> -->
                            <base-input addon-right-icon="fa fa-calendar">
                              <flat-picker
                                slot-scope="{ focus, blur }"
                                @on-open="focus"
                                @on-close="blur"
                                @input="checkdates"
                                :config="{ allowInput: true, minDate: 'today' }"
                                class="form-control datepicker"
                                v-model="datein"
                                :value="datein"
                              ></flat-picker>
                            </base-input>
                            <!-- <i class="fa fa-calendar fa-lg calendar" aria-hidden="true"></i> -->
                          </div>
                        </div>
                        <h6 class="">
                          {{ datein | formatDate }}
                          <input
                            type="hidden"
                            :value="datein | formatDate"
                            name="checkindate"
                          />
                        </h6>
                      </div>
                      <div class="col-lg-4 col-sm-12">
                        <h5>Check-Out Date</h5>

                        <div
                          class="
                            input-daterange
                            datepicker
                            row
                            align-items-center
                          "
                        >
                          <div class="col">
                            <base-input addon-right-icon="fa fa-calendar">
                              <flat-picker
                                slot-scope="{ focus, blur }"
                                @on-open="focus"
                                @on-close="blur"
                                :config="{ allowInput: true, minDate: datein }"
                                class="form-control datepicker"
                                v-model="dateout"
                                :value="dateout"
                              ></flat-picker>
                            </base-input>
                          </div>
                        </div>
                        <h6 v-if="dateout != 'invalid date'" class="">
                          {{ dateout | formatDate }}
                          <input
                            type="hidden"
                            :value="dateout | formatDate"
                            name="checkoutdate"
                          />
                        </h6>
                      </div>
                      <div class="col-lg-2 col-sm-12">
                        <h5>Travel Guide</h5>
                        <span class="check">
                          <input
                            type="checkbox"
                            id="travelguide"
                            name="travelguide"
                            :value="this.TravelGuide"
                            @change="totaladdTravelGuide($event, TravelGuide)"
                            ref="rolesSelected"
                          />
                          <label for="travelguide">
                            <div class="box">
                              <i class="fa fa-check"></i>
                            </div>
                            &nbsp;
                            <span class="addnolabel"
                              >{{ this.TravelGuide }}
                            </span>
                          </label>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div v-if="this.checkdetails == true">
                    <table>
                      <thead>
                        <th>Visa Type</th>
                        <th colspan="2">Add NO</th>
                        <th>Price</th>
                      </thead>
                      <tbody>
                        <tr v-if="this.checkEVisapopup == false">
                          <td>
                            <label class="ratelabel"
                              >{{ this.visatype }}
                            </label>
                          </td>

                          <td colspan="2" class="addnovaluediv">
                            <span
                              v-bind:key="checkkey"
                              class="check"
                              v-for="(himg, checkkey) in Object.entries(
                                JSON.parse(this.visaLabelAddOn)
                              )"
                            >
                              <input
                                type="checkbox"
                                :id="himg[0] + '-' + himg[1]"
                                :name="himg[0] + '-' + himg[1]"
                                :value="himg[0]  + ':' + himg[1]"
                                @change="totaladd($event, himg[1])"
                                v-model="addvaluearr"
                                ref="rolesSelectednew"
                              />
                              <label :for="himg[0] + '-' + himg[1]">
                                <div class="box">
                                  <i class="fa fa-check"></i>
                                </div>
                                &nbsp;
                                <span class="addnolabel"
                                  >{{ himg[0] }} : {{ himg[1] }}
                                </span>
                              </label>
                              <br />
                            </span>
                          </td>
                          <td>
                            <span class="labelrate">
                              &#8377; {{ this.visalabelRate }}</span
                            >
                            <label class="ratelabeltitel">
                              {{ this.visalabelRateTitle }}</label
                            ><br />
                            <label class="ratelabelsubtitel">
                              {{ this.visaLabelRateSubTitle }}</label
                            >
                          </td>
                        </tr>
                        <tr v-else-if="this.checkEVisapopup == true">
                          <td>
                            <label class="ratelabel"
                              >{{ this.visatype }}
                            </label>
                          </td>

                          <td colspan="2" class="addnovaluediv">
                            <span
                              class="check"
                              v-bind:key="checkkey"
                              v-for="(himg, checkkey) in Object.entries(
                                JSON.parse(this.visaERateAddOn)
                              )"
                            >
                              <input
                                type="checkbox"
                                :id="himg[0] + '-' + himg[1]"
                                :name="himg[0] + '-' + himg[1]"
                                :value="himg[0] + ':' + himg[1]"
                                @change="totaladd($event, himg[1])"
                                v-model="addvaluearr"
                                ref="rolesSelectedenew"
                              />
                              <label :for="himg[0] + ':' + himg[1]">
                                <div class="box">
                                  <i class="fa fa-check"></i>
                                </div>
                                &nbsp;
                                <span class="addnolabel"
                                  >{{ himg[0] }} : {{ himg[1] }}
                                </span> </label
                              ><br />
                            </span>
                            <!-- {{ this.visaERateAddOn }} -->
                          </td>
                          <td>
                            <span class="labelrate">{{ this.visaERate }}</span>
                            <label class="ratelabeltitel">
                              {{ this.visaERateTitle }}</label
                            >
                            <br />
                            <label class="ratelabelsubtitel">
                              ({{ this.visaERateSubTitle }})</label
                            >
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3" class="finaltotallabel">
                            Total Price
                          </td>
                          <td>
                            <span class="finaltotalamt">
                              &#8377;
                              {{ parseFloat(this.finaltotal).toFixed(2) }}

                              <input
                                type="hidden"
                                class="form-control"
                                :value="this.finaltotal"
                                name="totalpay"
                              />
                            </span>
                          </td>
                        </tr>
                        <!-- <tr>
                          <td>{{ this.backTopopus }}</td>
                        </tr> -->
                        <tr v-if="this.backTopopus == true">
                          <td colspan="4" class="text-center">
                            <a
                              href="javascript:void(0);"
                              @click="backpopus"
                              class="btn btn-warning"
                              >Back To {{ this.labelvalue }}</a
                            >
                          </td>
                        </tr>
                        <tr>
                          <td colspan="4" class="personal-details">
                            Personal Details
                          </td>
                        </tr>
                        <tr v-for="(g, i) in totalpersonvisa" v-bind:key="i">
                          <td>
                            <label class="documentLabel">{{ g }}) </label>
                          </td>
                          <td>
                            <label class="documentLabel documentLabel-firstname"
                              >First Name</label
                            >
                            <input
                              type="input"
                              :name="'firstname' + '-' + g"
                              class="form-control"
                              value
                              placeholder="First Name"
                              autocomplete="off"
                              maxlength="50"
                              onkeydown="return /[a-z]/i.test(event.key)"
                              required="required"
                              :id="'firstname' + '-' + g"
                            />
                          </td>
                          <td>
                            <label class="documentLabel documentLabel-firstname"
                              >Last Name</label
                            >
                            <input
                              type="input"
                              :name="'lastname' + '-' + g"
                              class="form-control"
                              value
                              placeholder="Last Name"
                              autocomplete="off"
                              maxlength="50"
                              onkeydown="return /[a-z]/i.test(event.key)"
                              required="required"
                              :id="'lastname' + '-' + g"
                            />
                          </td>
                          <td :id="'documentforvisa-fields-' + g">
                            <span
                              v-bind:key="documentforvisa"
                              v-for="(
                                docvisa, documentforvisa
                              ) in Object.entries(JSON.parse(visaDocument))"
                              ><span class="documentLabel d-inline-flex mb-3"
                                >{{ docvisa[0] }}
                                <div v-if="docvisa[1] == 'yes'">
                                  <span class="startforfield">*</span>
                                </div>
                              </span>

                              <br />

                              <input
                                type="file"
                                :id="docvisa[0] + '-' + g"
                                :name="docvisa[0] + '-' + g"
                                accept="image/*,application/pdf"
                                :required="docvisa[1] == 'yes' ? true : false"
                                v-on:change="
                                  handleFileUpload($event, docvisa[0] + '-' + g)
                                "
                              />
                              <hr />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="4" class="text-center p-5">
                            <button
                              class="btn btn-primary"
                              @click.prevent="savedata"
                            >
                              Save
                            </button>
                            <button
                              class="btn btn-danger"
                              @click.prevent="canceldata"
                            >
                              Cancel
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </form>
              </card>
            </div>
          </div>
        </div>
      </section>
    </div>

    <modal
      class=""
      name="evisapopup"
      draggable=".window-header"
      :adaptive="true"
      :clickToClose="false"
    >
      <div class="epopupbox">
        <div v-html="visaEPopup"></div>
        <div class="epopup-btn">
          <button class="btn btn-danger" @click="clickno">Label-Visa</button>
          <button class="btn btn-primary" @click="clickyes">E-Visa</button>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import axios from "axios";
import { APIURLS } from "../api/constants.js";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import DemoLoginModal from "../views/modals/modal_login";
import { log } from "console";

export default {
  name: "visa",
  // mounted () {

  //   },
  components: {
    flatPicker,
    DemoLoginModal,
  },

  data() {
    return {
      visa_country: null,
      countryvalue: null,
      visa_countryName: null,
      countryoptions: [
        {
          visa_country: "0",
          name: "Please type slowly and select country",
        },
      ],
      isCountryLoading: false,
      passCountry: 0,
      enter_country: null,
      entervalue: null,
      enteroption: [
        {
          visa_entry: "0",
        },
      ],
      isEnterLoading: false,

      guests: 1,
      maxguests: 6,
      fullguests: false,
      datein: new Date(),
      dateout: new Date(new Date().setDate(new Date().getDate() + 1)),
      dates: {
        simple: "2016-07-17",
        rangein: new Date(),
        rangeout: new Date().setDate(new Date().getDate() + 1),
      },
      visalabelRate: 0,
      visalabelRateTitle: null,
      visaLabelRateSubTitle: null,
      visaLabelAddOn: [],
      visaERate: 0,
      visaERateTitle: null,
      visaERateSubTitle: null,
      visaERateAddOn: [],
      visaEPopup: null,
      visaDocument: [],
      checkEVisapopup: false,
      checkdetails: false,
      finaltotal: 0,
      totalpersonvisa: 0,
      backTopopus: false,
      labelvalue: null,
      totalAddno: 0,
      UserDetail: [],
      userid: localStorage.getItem("customer_id"),
      ratePerPerson: 0,
      file: [],
      TravelGuide: 0,
      visatype: null,
      addvaluearr: [],
      enterpass: null,
    };
  },
  methods: {
    optionSelected(option) {
      this.visa_countryName = option.name;
      this.checkdetails = false;
      this.enteroption = "";
      this.entervalue = "";
    },
    clickno() {
      this.checkEVisapopup = false;
      this.labelvalue = "E-Visa";
      this.$modal.hide("evisapopup");
      this.checkdetails = true;
      this.finaltotal = this.visalabelRate;
      this.ratePerPerson = this.visalabelRate;
      this.visatype = "Label-Visa";
      this.checkadults();
    },
    clickyes() {
      this.checkEVisapopup = true;
      this.labelvalue = "Label-Visa";
      this.$modal.hide("evisapopup");
      this.checkdetails = true;
      this.finaltotal = this.visaERate;
      this.ratePerPerson = this.visaERate;
      this.visatype = "E-Visa";
      this.checkadults();
    },
    backpopus() {
      this.showModal = true;
      this.$modal.show("evisapopup");
    },
    getUserDetail() {
      var urltogouser = APIURLS.GET_GETUSER_DETAIL + "?userid=" + this.userid;
      axios.get(urltogouser).then((response) => {
        this.UserDetail = response;
        
      });
      
      
    },
    handleFileUpload(event, dockey) {
      let d = dockey;
      let file = event.target.files[0];
      this.file.push({ [d]: file });
    },
    savedata() {
      let addno=(JSON.stringify(this.addvaluearr));
      addno=addno.replaceAll(":",'":"').replace('[','').replace(']','');
      var islog = localStorage.getItem("loggedIn");
      if (islog == "yes") {
        let myForm = document.getElementById("visa-form");
        let TravelGuideAmt = 0;
        if (this.$refs.rolesSelected.checked == true) {
          TravelGuideAmt = this.TravelGuide;
        }

        var content = "";
        let personname='';

        let countguest = this.totalpersonvisa;
        var guestnumber = 1;
        let formData = new FormData(myForm);
        formData.append("file", this.file);
        for (let i = 1; i <= countguest; i++) {
          let firstname = document.getElementById("firstname-" + i).value;
          let lastName = document.getElementById("lastname-" + i).value;
          content += "Guest " + guestnumber + " FirstName:" + firstname + ",";
          content += "Guest " + guestnumber + " LastName:" + lastName + ",";
          personname+=  firstname+' '+lastName;
          guestnumber++;
        }
        var Indate = moment(this.datein).format("YYYY-MM-DD");
        var Outdate = moment(this.dateout).format("YYYY-MM-DD");
        var now = moment(Indate),
          end = moment(Outdate),
          days = end.diff(now, "days");
        this.diffdate = days;
        let sub_total = this.totalpersonvisa * this.ratePerPerson;
        formData.append("email", this.UserDetail.data[0].email);
        formData.append("mobile", this.UserDetail.data[0].phone);
        formData.append("specialreq", "");
        formData.append("cemail", "");
        formData.append("cmobile", "");
        formData.append("companyname", "");
        formData.append("gst", "");
        formData.append("caddress", this.UserDetail.data[0].billing_address);
        formData.append("ccity", this.UserDetail.data[0].shipping_city);
        formData.append("cpincode", this.UserDetail.data[0].shipping_zip);
        formData.append("customer", localStorage.getItem("customer_id"));
        formData.append("total_items", "1");
        formData.append("comment", "true");
        formData.append(
          "subject",
          "Visa Booking by " + localStorage.getItem("name")
        );
        formData.append("status", "2");
        formData.append("assigned", "1");
        formData.append("sub_total", sub_total);
        formData.append("total_discount", "0");
        formData.append("total_tax", "0");
        formData.append("extra_person_charges", "0");
        formData.append("total", this.finaltotal);

        content += "CountryName:" + this.visa_countryName + ",";
        content += "CountryCode:" + this.passCountry + ",";
        content +=
          "CheckInDate:" +
          moment(String(this.datein)).format("YYYY-MM-DD") +
          ",";
        content +=
          "CheckOutDate:" +
          moment(String(this.dateout)).format("YYYY-MM-DD") +
          ",";
        formData.append("content", content);
        var pricedetails = "";

        pricedetails += "Totaldates:" + this.diffdate + ",";
        formData.append("pricedetails", pricedetails);
        formData.append("items[0][name]", "visa");
        formData.append("items[0][product_id]", this.passCountry);
        formData.append("items[0][code]", this.passCountry);
        formData.append(
          "items[0][description]",
          "{'name':'visa','product_id':" +"'"+
            this.passCountry +
            "','code':" +"'"+
            this.passCountry +
            "','checkindate':'"+  moment(String(this.datein)).format("YYYY-MM-DD")+"','checkoutdate':'"+ moment(String(this.dateout)).format("YYYY-MM-DD")+"','typeofvisa':'"+ this.visatype+ "','typeofentry':'" +
            this.enterpass +"','personname':'"+personname+"','quantity':'"+this.totalpersonvisa+"','unit':'Unit','price':'"+sub_total+"','netamt':'"+sub_total+"','countryfrom':'"+this.visa_countryName+"','travelguide':'" +TravelGuideAmt +"','addno':[{"+addno+"}]}"
        );
        formData.append("items[0][quantity]", this.totalpersonvisa);
        formData.append("items[0][dates]", this.diffdate);
        formData.append("items[0][total]", this.finaltotal);
        formData.append("items[0][unit]", "Unit");
        formData.append("items[0][extra_person_charges]", "0");
        formData.append("items[0][price]", this.finaltotal);
        formData.append("items[0][tax]", "0");
        formData.append("items[0][discount]", "0");
        formData.append("date", moment(String(new Date())).format("YYYY-M-DD"));
        formData.append(
          "opentill",
          moment(String(new Date())).add(12, "days").format("YYYY-M-DD")
        );
        formData.append("checkindate", this.datein);
        formData.append("checkoutdate", this.dateout);

        axios
          .post(APIURLS.BOOK_URL, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.showLoading = false;
            var data = response.data;
            if (data.success) {
              this.$router.push({
                path: "orderdone",
                query: { orderid: data.id },
              });
            } else {
              this.errorString = data.message;
              this.showError = true;
            }
          });
      } else {
        this.$modal.show("demo-login", {
          show: true,
        });
      }
    },
    canceldata() {
      window.location.reload();
    },
    getVisaCountry() {
      axios.get(APIURLS.GET_ViSA_DATA).then((response) => {
        this.countryoptions = response.data;
      });
    },
    limitText(count) {
      return `and ${count} other cities`;
    },
    getCountry(query) {
      this.clearCountry();
      this.isCountryLoading = true;
      var urltogo = APIURLS.GET_COUNTRY + "?q=" + query;
      axios.get(urltogo).then((response) => {
        this.countryoptions = response.data;
        this.isCountryLoading = false;
      });
    },
    clearCountry() {
      this.countryoptions = [];
    },
    checkadults() {
      this.maxguests = this.maxguests - this.guests;
      if (this.guests == 6) {
        this.fullguests = true;
      } else if (this.guests < 6) {
        this.fullguests = false;
      }
      this.totalguest = this.guests;
      this.totalpersonvisa = this.guests;

      if (this.visaEPopup && this.checkEVisapopup == true) {
        this.finaltotal = this.visaERate;
      } else {
        this.finaltotal = this.visalabelRate;
      }

      this.finaltotal =
        this.finaltotal * this.totalpersonvisa + this.totalAddno;
    },
    checkdates() {
      this.dateout = "";
      this.dateout = moment(String(this.datein))
        .add(1, "day")
        .format("YYYY-MM-DD");
      this.$forceUpdate();
    },
    totaladd: function (event, amt) {
      if (event.target.checked === true) {
        this.finaltotal =
          Number(this.finaltotal) + Number(amt) * this.totalpersonvisa;
        this.totalAddno = this.totalAddno + Number(amt) * this.totalpersonvisa;
      } else {
        this.finaltotal =
          Number(this.finaltotal) - Number(amt) * this.totalpersonvisa;
        this.totalAddno = this.totalAddno - Number(amt) * this.totalpersonvisa;
      }
    },
    getenter(selectedItems) {
      let country_no = selectedItems.visa_country;
      this.isEnterLoading = true;
      var urlGetEnterFromCountry = APIURLS.GET_VISAENTRY + "?q=" + country_no;
      axios.get(urlGetEnterFromCountry).then((response) => {
        if (!response.length) {
          this.enteroption = response.data;
          this.passCountry = country_no;
          this.isEnterLoading = false;
        }
      });
    },
    executeLoader(selectedItems) {
      let country_no = this.passCountry;
      let enter = selectedItems.visa_entry;
      this.enterpass = enter;
      var urltogetfromdetail =
        APIURLS.GET_COUNTRYVISADETAIL + "?q=" + country_no + "&enter=" + enter;
      axios.get(urltogetfromdetail).then((response) => {
        if (!response.length) {
          this.visalabelRate = response.data[0].visa_label_rate;
          this.visalabelRateTitle = response.data[0].visa_label_rate_title;
          this.visaLabelRateSubTitle =
            response.data[0].visa_label_rate_subtitle;
          this.visaLabelAddOn = response.data[0].visa_label_add_on;
          this.visaERate = response.data[0].visa_e_rate;
          this.visaERateTitle = response.data[0].visa_e_rate_title;
          this.visaERateSubTitle = response.data[0].visa_e_rate_subtitle;
          this.visaERateAddOn = response.data[0].visa_e_add_on;
          this.visaEPopup = response.data[0].visa_e_popus;
          this.visaDocument = response.data[0].visa_documents;
          this.TravelGuide = response.data[0].visa_travel_guide;
          if (this.visaEPopup) {
            this.showModal = true;
            this.$modal.show("evisapopup");
            this.finaltotal = this.visaERate;
            this.checkEVisapopup = true;
            this.backTopopus = true;
          } else {
            this.checkdetails = true;
            this.finaltotal = this.visalabelRate;
            this.checkEVisapopup = false;
          }
        }
      });
    },
    totaladdTravelGuide(event, amount) {
      if (event.target.checked === true) {
        this.finaltotal = Number(this.finaltotal) + Number(amount);
      } else {
        this.finaltotal = Number(this.finaltotal) - Number(amount);
      }
    },
  },

  created() {
    this.getUserDetail();
    
    this.getVisaCountry("");
  },
};
</script>
<style scoped>
.number-input,
.number-input__input,
.number-input--inline > input {
  width: 100% !important;
}
.number-input > input {
  display: inline-block;
  width: 100% !important;
}
.ratelabel {
  font-size: 1.5rem;
  font-weight: 700;
  color: #32325d;
}
.labelrate {
  color: #09a6cf;
  font-size: 1.5rem;
  padding-right: 1em;
  display: block;
  font-weight: 400;
}
.ratelabeltitel {
  font-size: 1rem;
  font-weight: 500;
  color: #32325d;
}
.ratelabelsubtitel {
  font-size: 0.9rem;
  font-weight: 400;
  color: #32325d;
}
.epopupbox {
  position: relative;
  padding: 1em;
  height: 100%;
  border: 1px solid;
}
.epopup-btn {
  position: absolute;
  bottom: 10%;
  left: 0;
  right: 0;
  margin: auto;
  width: 40%;
}
.form-group {
  margin-bottom: 0.2rem;
}
h6 {
  margin-left: 0.2em;
}
.multiselect__tags {
  padding: 8px 40px 2px 8px;
}
.number-input__input {
  line-height: 1.8 !important;
}
table {
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
  vertical-align: top;
}

tr:nth-child(even) {
  background-color: #d7d7da40;
}
.finaltotallabel,
.personal-details {
  font-size: 1.5rem;
  font-weight: 600;
  color: #17284d;
}
.finaltotalamt {
  font-size: 1.5rem;
  font-weight: 700;
  color: #09a6cf;
}
input[type="checkbox"] {
  vertical-align: middle;
}
.documentLabel {
  font-size: 1.2rem;
  font-weight: 700;
  text-transform: capitalize;
}
.startforfield,
.documentLabel-firstname::after {
  font-size: 0.83em;
  line-height: 0.5em;
  vertical-align: baseline;
  position: relative;
  top: -0.4em;
  color: red;
  left: 0.3rem;
}
.documentLabel-firstname::after {
  content: "*";
}
.check input {
  display: none;
}
.addnolabel {
  font-size: 1rem;
  font-weight: 700;
}
.check input:checked + label .box {
  -webkit-animation: animOnTransform 1s 1 forwards;
  animation: animOnTransform 1s 1 forwards;
  background: rgb(249 237 138);
}

.check input:checked + label .box i {
  transform: translate(-50%, -50%) scale(1);
  transition-duration: 200ms;
  transition-delay: 400ms;
  opacity: 1;
}

.check label {
  min-width: 100px;
  display: flex;
  /* justify-content: center; */
  align-items: center;
  flex-direction: row;
  min-height: auto;
  cursor: pointer;
}

.check label .box {
  background: transparent;
  border-radius: 5px;
  position: relative;
  width: 25px;
  height: 25px;
  transition: background 300ms ease;
  border: 1px solid #000;
  margin-right: 1rem;
}

.check label .box:hover {
  background: rgb(249 237 138);
}

.check label .box i {
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 20px;
  display: inline-block;
  opacity: 0;
  pointer-events: none;
  transition: all 0.2s ease-in-out;
  transition-delay: 200ms;
  transform: translate(-50%, -50%) scale(4);
}

@-webkit-keyframes animOn {
  40% {
    height: 20px;
    width: 100px;
  }

  50% {
    height: 60px;
    width: 30px;
  }

  60% {
    height: 40px;
    width: 70px;
  }

  70% {
    height: 55px;
    width: 45px;
  }

  100% {
    height: 50px;
    width: 50px;
  }
}

@keyframes animOn {
  40% {
    height: 20px;
    width: 100px;
  }

  50% {
    height: 60px;
    width: 30px;
  }

  60% {
    height: 40px;
    width: 70px;
  }

  70% {
    height: 55px;
    width: 45px;
  }

  100% {
    height: 50px;
    width: 50px;
  }
}

@-webkit-keyframes animOnTransform {
  40% {
    transform: scale(1.5, 0.5);
  }

  50% {
    transform: scale(0.5, 1.5);
  }

  60% {
    transform: scale(1.3, 0.6);
  }

  70% {
    transform: scale(0.8, 1.2);
  }

  100% {
    transform: scale(1, 1);
  }
}

@keyframes animOnTransform {
  40% {
    transform: scale(1.5, 0.5);
  }

  50% {
    transform: scale(0.5, 1.5);
  }

  60% {
    transform: scale(1.3, 0.6);
  }

  70% {
    transform: scale(0.8, 1.2);
  }

  100% {
    transform: scale(1, 1);
  }
}

/* end of custom code */

@media only screen and (max-width: 760px),
  (min-device-width: 768px) and (max-device-width: 1024px) {
  .number-input__input {
    width: 22.5rem !important;
  }
  /* Force table to not be like tables anymore */
  table,
  thead,
  tbody,
  th,
  td,
  tr {
    display: block;
  }

  th {
    display: none;
  }

  tr:last-child td {
    display: inline-flex;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  /* tr {
    margin: 0 0 1rem 0;
  } */

  tr:nth-child(odd) {
    background: #ccc;
  }

  tbody tr:first-child td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 30%;
  }

  tbody tr:first-child td:before {
    /* Now like a table header */
    position: absolute;
    /* Top/left values mimic padding */
    top: 22%;
    left: 6px;
    width: 30%;
    padding-right: 10px;
    white-space: nowrap;
  }

  /*
		Label the data
    You could also use a data-* attribute and content for this. That way "bloats" the HTML, this way means you need to keep HTML and CSS in sync. Lea Verou has a clever way to handle with text-shadow.
		*/
  tbody tr:first-child td:nth-of-type(1):before {
    content: "Visa Type : ";
  }
  tbody tr:first-child td:nth-of-type(2):before {
    content: "Price : ";
  }
  tbody tr:first-child td:nth-of-type(3):before {
    content: "Add NO : ";
  }
  .epopup-btn {
    width: 60%;
  }
}
</style>